export default __webpack_public_path__ + "static/media/ar.65815024.jpg";